import Vue from 'vue'
import VueI18n from 'vue-i18n'
import customZhCn from './lang/zh-CN'
import customZhTw from './lang/zh-TW'
// import customEnUs from './lang/en-US'
import zhCnLocale from 'iview/src/locale/lang/zh-CN'
// import enUsLocale from 'iview/src/locale/lang/en-US'
import zhTwLocale from 'iview/src/locale/lang/zh-TW'
import element_locale from 'element-ui/lib/locale'
import element_zh_CN from 'element-ui/lib/locale/lang/zh-CN'
import element_zh_TW from 'element-ui/lib/locale/lang/zh-TW'
// import element_en_US from 'element-ui/lib/locale/lang/en'

Vue.use(VueI18n)

element_locale.i18n((key, value) => i18n.t(key, value))

// 自动根据浏览器系统语言设置语言
const navLang = localStorage.getItem('local') || navigator.language
const localLang = (navLang === 'zh-CN' || navLang === 'zh-TW') ? navLang : navLang === 'zh' ? 'zh-CN' : false
let lang = localLang || 'zh-CN'
Vue.config.lang = lang
// vue-i18n 6.x+写法
Vue.locale = () => {}
const messages = {
  'zh-CN': Object.assign(customZhCn, zhCnLocale, element_zh_CN),
  'zh-TW': Object.assign(customZhTw, zhTwLocale, element_zh_TW),
  // 'en-US': Object.assign(customEnUs, enUsLocale, element_en_US)
}
const i18n = new VueI18n({
  locale: lang,
  messages,
  silentTranslationWarn: true
})

export default i18n



// WEBPACK FOOTER //
// ./src/locale/index.js